import ErrorBoundary from './ErrroBoundary';

export default ErrorBoundary;
